import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const sections = [
  {
    h: "1. Acceptance of Terms",
    p: "By accessing or using Reveal, you agree to be bound by these Terms and Conditions. If you do not agree, please do not use the service.",
  },
  {
    h: "2. Eligibility",
    p: "You must be at least 18 years old to use Reveal. By using the service you represent that you meet this requirement and that all information you provide is accurate.",
  },
  {
    h: "3. Your Account",
    p: "You are responsible for maintaining the confidentiality of your account and for all activity that occurs under it. Profiles may be subject to age and face verification.",
  },
  {
    h: "4. Acceptable Use",
    p: "You agree not to harass, impersonate, or harm other members, and not to use Reveal for any unlawful purpose. We may suspend accounts that violate these terms.",
  },
  {
    h: "5. Subscriptions & Payments",
    p: "Paid tiers renew automatically unless cancelled. Prices are shown at checkout and may change with notice. Every tier gives the same access to genuine connection.",
  },
  {
    h: "6. Changes to These Terms",
    p: "We may update these Terms from time to time. Continued use of Reveal after changes take effect constitutes acceptance of the revised Terms.",
  },
];

export default function Terms() {
  return (
    <div className="min-h-screen bg-reveal-black text-reveal-cream font-body px-5 py-16" data-testid="terms-page">
      <div className="max-w-2xl mx-auto">
        <Link
          to="/landing"
          data-testid="terms-back-link"
          className="inline-flex items-center gap-2 text-sm text-reveal-rose hover:text-reveal-cream transition-colors mb-10"
        >
          <ArrowLeft className="w-4 h-4" /> Back to Reveal
        </Link>
        <h1 className="font-heading text-4xl sm:text-5xl text-reveal-cream mb-3">Terms and Conditions</h1>
        <p className="text-sm text-reveal-cream/45 mb-12">Last updated: June 2026</p>
        <div className="space-y-9">
          {sections.map((s) => (
            <section key={s.h}>
              <h2 className="font-heading text-2xl text-reveal-rose mb-2">{s.h}</h2>
              <p className="text-reveal-cream/70 leading-relaxed">{s.p}</p>
            </section>
          ))}
        </div>
        <p className="mt-14 text-sm text-reveal-cream/45">
          Questions? Reach us at{" "}
          <a href="mailto:hello@getrevealapp.com" className="text-reveal-rose hover:text-reveal-cream transition-colors">
            hello@getrevealapp.com
          </a>
        </p>
      </div>
    </div>
  );
}
